// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"868ba2fd","850":"5b37a5b8"}[chunkId] + ".chunk.js";
};